import {core} from './core.js';

export const definitions = {
    ... core
};
